import { defineAction } from '@cheesecakelabs/boilerplate/utils'

import * as mindfulBreaksService from '_services/mindful-breaks'

export const GET_MINDFUL_BREAKS = defineAction('GET_MINDFUL_BREAKS')
export const SET_MINDFUL_BREAKS_ORDER = defineAction('SET_MINDFUL_BREAKS_ORDER')
export const DELETE_MINDFUL_BREAK = defineAction('DELETE_MINDFUL_BREAK')
export const CREATE_MINDFUL_BREAK = defineAction('CREATE_MINDFUL_BREAK')
export const UPDATE_MINDFUL_BREAK = defineAction('UPDATE_MINDFUL_BREAK')
export const TOGGLE_REMINDER_MINDFUL_BREAK = defineAction('TOGGLE_REMINDER_MINDFUL_BREAK')
export const DISABLE_REMINDER_TYPE_MINDFUL_BREAK = defineAction('DISABLE_REMINDER_TYPE_MINDFUL_BREAK')

export const getMindfulBreaks = () => (dispatch, getState) =>
  dispatch({
    type: GET_MINDFUL_BREAKS.ACTION,
    payload: mindfulBreaksService.getMindfulBreaks(getState().user.get('token')),
  })

export const setMindfulBreaksOrder = payload => (dispatch, getState) =>
  dispatch({
    type: SET_MINDFUL_BREAKS_ORDER.ACTION,
    payload: mindfulBreaksService
      .setMindfulBreaksOrder(getState().user.get('token'))(payload)
      .then(() => mindfulBreaksService.getMindfulBreaks(getState().user.get('token'))),
  })

export const deleteMindfulBreak = id => (dispatch, getState) =>
  dispatch({
    type: DELETE_MINDFUL_BREAK.ACTION,
    payload: mindfulBreaksService
      .deleteMindfulBreak(getState().user.get('token'))(id)
      .then(() => id),
  })

export const createMindfulBreak = payload => (dispatch, getState) =>
  dispatch({
    type: CREATE_MINDFUL_BREAK.ACTION,
    payload: mindfulBreaksService
      .createMindfulBreak(getState().user.get('token'))(payload)
      .then(() => mindfulBreaksService.getMindfulBreaks(getState().user.get('token'))),
  })

export const editMindfulBreak = (id, payload) => (dispatch, getState) =>
  dispatch({
    type: UPDATE_MINDFUL_BREAK.ACTION,
    payload: mindfulBreaksService
      .updateMindfulBreak(getState().user.get('token'))(id, payload)
      .then(() => mindfulBreaksService.getMindfulBreaks(getState().user.get('token'))),
  })

export const disableReminderType = payload => (dispatch, getState) =>
  dispatch({
    type: DISABLE_REMINDER_TYPE_MINDFUL_BREAK.ACTION,
    payload: mindfulBreaksService
      .disableReminderType(getState().user.get('token'))(payload)
      .then(() => mindfulBreaksService.getMindfulBreaks(getState().user.get('token'))),
  })

export const toggleReminderMindfulBreak = id => (dispatch, getState) =>
  dispatch({
    type: TOGGLE_REMINDER_MINDFUL_BREAK.ACTION,
    payload: mindfulBreaksService
      .toggleReminderMindfulBreak(getState().user.get('token'))(id)
      .then(() => mindfulBreaksService.getMindfulBreaks(getState().user.get('token'))),
  })



// WEBPACK FOOTER //
// ./src/modules/mindful-breaks/actions.js